export default __webpack_public_path__ + "static/media/vertical-line.810ae8bd.svg";